import { ArrowRightIcon } from "@heroicons/react/24/outline";

export default function Introduction(setSelectedSection) {
  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">Introduction</h1>
      <p className="mb-3 text-gray-700">
        Whenfin is a developer tool that allows you to send mobile push
        notifications directly from your code. Scripts can take a long time to
        run or crash unexpectedly—Whenfin lets you step away and come back when
        needed. The service requires a mobile app and includes a recommended
        Python wrapper for interacting with our API.
      </p>
      <div className="flex gap-4">
        <a
          href="https://apps.apple.com/us/app/whenfin/id6504001973"
          className="transition rounded-md inline-block bg-gray-200 px-3.5 py-2.5 my-4 text-sm font-semibold text-gray-700 shadow-sm "
        >
          Download the app
        </a>
        <a
          onClick={() => {
            setSelectedSection("Getting Started");
          }}
          className="transition rounded-md inline-flex flex-row items-center gap-2 bg-indigo-600 px-3.5 py-2.5 my-4 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:ring ring-indigo-600 ring-offset-2"
        >
          See how to get started
          <ArrowRightIcon className="w-5 h-5" />
        </a>
      </div>
    </section>
  );
}
